import { render, staticRenderFns } from "./PagamentoSteps.vue?vue&type=template&id=9d5e9d1c"
import script from "./PagamentoSteps.vue?vue&type=script&lang=ts"
export * from "./PagamentoSteps.vue?vue&type=script&lang=ts"
import style0 from "./PagamentoSteps.vue?vue&type=style&index=0&id=9d5e9d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports